/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Private_Models_Last_Health_CheckInputs */



/**
* | output |
* | --- |
* | "Last checked {date}" |
*
* @param {Private_Models_Last_Health_CheckInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_last_health_check = /** @type {((inputs: Private_Models_Last_Health_CheckInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Last_Health_CheckInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zuletzt geprüft ${i?.date}`)
	return /** @type {LocalizedString} */ (`Last checked ${i?.date}`)
});